import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOrderTrend as _getOrderTrend, getConsumeTrend as _getConsumeTrend, exportOrderTrend, getCostRateData, exportCostRange, getOperationLog, addOperationLog, getConsumeOrderLog, getStatisticsAuditRisk as _getStatisticsAuditRisk, getCategoryCostExport, getCategoryCostTrend, exportOrderEvaluate, getPlateDetailPieChart } from '../api/index';
import { isNumber } from '@/utils';
import LogTableData from '@/views/order/components/logTableData';
import customerSet from '@/views/serviceCenter/workBench/components/customerSet';
import cardCommonConfig from '@/views/order/cardCommonConfig';
import menuDetailDrawer from '@/views/platformReport/components/menuDetailDrawer.vue';
import cityStatistics from '@/views/platformReport/components/cityStatistics.vue';
import provinceStatistics from '@/views/platformReport/components/provinceStatistics.vue';
import evaluateDetailDrawer from '@/views/platformReport/components/evaluateDetailDrawer.vue';
export default {
  name: 'order-consume-details',
  filters: {
    filterDate: function filterDate(v) {
      if (v) {
        return v.split(' ')[0];
      }
      return v;
    }
  },
  components: {
    menuDetailDrawer: menuDetailDrawer,
    cityStatistics: cityStatistics,
    provinceStatistics: provinceStatistics,
    LogTableData: LogTableData,
    customerSet: customerSet,
    cardCommonConfig: cardCommonConfig,
    evaluateDetailDrawer: evaluateDetailDrawer
  },
  props: {
    orderId: [Number, String],
    activeNameDefault: String,
    detailActiveName: String,
    entry: String,
    searchData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    var _this2 = this;
    return {
      menuDetailVisible: false,
      // 商城菜单统计 - 明细 弹窗是否显示
      menuDetailParams: {},
      activeName: '1',
      grossName: '1',
      activeNameChart: '',
      gross_profit_type: '',
      // 订单金额  0:应收 1:实收 2:已售
      orderInfo: {},
      grossInfo: {},
      list: [],
      // 表格数据
      statsData: {},
      // 折线图数据
      orderTypeList: [],
      //订单类型消费占比
      businessTypeList: [],
      //业务类型消费占比
      consumeScenarioList: [],
      //消费场景占比

      paging: {
        page: 1,
        page_size: 50,
        totalCount: 0
      },
      costTypeList: [],
      // 订单消费趋势 - 类型列表
      cost_order_type: '',
      // 订单消费趋势 - 类型
      rateTypeList: [],
      // 订单成本率趋势 - 类型列表
      searchForm: {
        rate_order_type: '',
        // 订单成本率趋势 - 类型
        date_time: [] // 订单成本率趋势 - 时间搜索项
      },
      costRateList: [],
      //订单成本率趋势 - 列表数据
      costRateChart: {},
      //订单成本率趋势 - 折线图数据

      evaluateList: [],
      // 售后数据 - 列表数据
      order_evaluate: {},
      // 售后数据 - 订单评价
      plateDetailList: [],
      // 板块明细 - 列表数据
      categoryCostList: [],
      // 商城菜单统计 - 列表
      categoryCostPaging: {
        page: 1,
        pagesize: 20,
        totalCount: 0
      },
      grossList: [[{
        label: '消费率',
        formatter: function formatter() {
          return _this2.grossInfo.consume_rate + '%';
        }
      }, {
        label: '留存率',
        formatter: function formatter() {
          return _this2.grossInfo.available_rate + '%';
        }
      }, {
        label: '绑卡率',
        formatter: function formatter() {
          return _this2.grossInfo.bind_card_rate + '%';
        }
      }, {
        label: '全留率',
        formatter: function formatter() {
          return _this2.grossInfo.un_use_card_rate + '%';
        }
      }, {
        label: '零留率',
        formatter: function formatter() {
          return _this2.grossInfo.zero_card_rate + '%';
        }
      }, {
        label: '推测留存率',
        formatter: function formatter() {
          return _this2.grossInfo.prediction_available_rate + '%';
        }
      }], [{
        label: '含留存毛利',
        value: 'gross_profit'
      }, {
        label: '含留存毛利率',
        formatter: function formatter() {
          var gross_profit_rate = _this2.grossInfo.gross_profit_rate;
          if (isNumber(gross_profit_rate, true)) {
            return gross_profit_rate + '%';
          }
          return gross_profit_rate;
        }
      }, {
        label: '不含留存毛利',
        value: 'consume_gross_profit'
      }, {
        label: '不含留存毛利率',
        formatter: function formatter() {
          var consume_gross_profit_rate = _this2.grossInfo.consume_gross_profit_rate;
          if (isNumber(consume_gross_profit_rate, true)) {
            return consume_gross_profit_rate + '%';
          }
          return consume_gross_profit_rate;
        }
      }, {
        label: '推测含留存毛利',
        value: 'prediction_gross_profit'
      }, {
        label: '推测含留存毛利率',
        formatter: function formatter() {
          var prediction_gross_profit_rate = _this2.grossInfo.prediction_gross_profit_rate;
          if (isNumber(prediction_gross_profit_rate, true)) {
            return prediction_gross_profit_rate + '%';
          }
          return prediction_gross_profit_rate;
        }
      }]],
      orderInfoList: [
      // {
      // 	label: '订单号',
      // 	value: 'id',
      // 	handle: key => {
      // 		const src = `${
      // 			this.$store.state.user.domainName
      // 		}/#/order/orderDetails?order_id=${this.orderInfo[key]}`
      // 		window.open(src, '_blank')
      // 	},
      // 	style: {
      // 		color: '#409EFF',
      // 		cursor: 'pointer'
      // 	}
      // },
      {
        label: '业务类型',
        value: 'card_bin_group_name'
      }, {
        label: '卡类型',
        value: 'card_bin_name',
        tooltip: true
      }, {
        label: '客户名称',
        value: 'customer_name',
        tooltip: true
      }, {
        label: '客户性质',
        value: 'nature'
      }, {
        label: '负责人',
        value: 'user_name'
      }, {
        label: '应收',
        value: 'shou_money'
      }, {
        label: '实收',
        value: 'finance_money'
      }, {
        label: '售卡点数',
        value: 'card_sale_points'
      }, {
        label: '消费点数',
        value: 'consume_points'
      }, {
        label: '剩余点数',
        value: 'available_points'
      }, {
        label: '售卡有效期',
        formatter: function formatter() {
          var _this2$orderInfo = _this2.orderInfo,
            _this2$orderInfo$star = _this2$orderInfo.start_card_date,
            start_card_date = _this2$orderInfo$star === void 0 ? '' : _this2$orderInfo$star,
            _this2$orderInfo$end_ = _this2$orderInfo.end_card_date,
            end_card_date = _this2$orderInfo$end_ === void 0 ? '' : _this2$orderInfo$end_;
          start_card_date = start_card_date ? start_card_date.split('-')[0] : '';
          end_card_date = end_card_date ? end_card_date.split('-')[0] : '';
          return "".concat(start_card_date, " - ").concat(end_card_date);
        }
      }, {
        label: '售卡数量',
        value: 'card_sale_num'
      }, {
        label: '卡类型差异度',
        value: 'rule_diff_rate',
        formatter: function formatter() {
          var rule_diff_rate = _this2.orderInfo.rule_diff_rate;
          return rule_diff_rate + '%';
        }
      }, {
        label: '销售折扣',
        value: 'discount',
        style: {
          color: 'red'
        },
        label_style: {
          color: 'red'
        }
      }, {
        label: '优惠卷成本',
        value: 'service_cost'
      }, {
        label: '服务成本',
        value: 'company_cost'
      }, {
        label: '成本率',
        value: 'cost_rate',
        style: {
          color: 'red'
        },
        label_style: {
          color: 'red'
        },
        formatter: function formatter() {
          var cost_rate = _this2.orderInfo.cost_rate;
          return cost_rate + '%';
        }
      }, {
        label: '创建时间',
        value: 'created_at'
      }, {
        label: '交付负责人',
        value: 'loser_user',
        formatter: function formatter() {
          var loser_user = _this2.orderInfo.loser_user;
          return loser_user || '-';
        }
      }, {
        label: '成本率目标',
        value: 'target_cost_rate',
        formatter: function formatter() {
          var target_cost_rate = _this2.orderInfo.target_cost_rate;
          return target_cost_rate || target_cost_rate === 0 || target_cost_rate === '0' ? target_cost_rate + '%' : '-';
        }
      }],
      operateDialog: false,
      operateForm: {
        text: ''
      },
      operateLogList: [],
      //运营日志
      operateLogPages: {
        page: 1,
        page_size: 20,
        totalCount: 0
      },
      // 运营日志分页

      logPage: 1,
      orderLogList: [],
      //操作日志
      logDataPages: {},
      // 操作日志分页
      cardRuleList: [],
      orderType: null,
      trendParams: {},
      evaluateDetailVisible: false,
      // 评价明细数据 drawer 显示状态
      pageDesc: '' // 板块明细底部 HTML 描述
    };
  },
  methods: {
    // 商城菜单统计 - 点击“明细”
    onClickMenuDetail: function onClickMenuDetail(row) {
      this.menuDetailParams = _objectSpread({
        order_id: this.orderId
      }, row);
      this.menuDetailVisible = true;
    },
    // 商城菜单统计 - 关闭明细
    onCloseMenuDetail: function onCloseMenuDetail() {
      this.menuDetailParams = {};
      this.menuDetailVisible = false;
    },
    // 操作日志分页
    logDataPage: function logDataPage(val) {
      this.logPage = val;
      this.getOrderLog();
    },
    // 操作日志
    getOrderLog: function getOrderLog() {
      var _this3 = this;
      var params = {
        page: this.logPage,
        order_id: this.orderId
      };
      getConsumeOrderLog(params).then(function (res) {
        _this3.orderLogList = res.data;
        _this3.logDataPages = res.pages;
      });
    },
    openOperateDialog: function openOperateDialog() {
      var _this4 = this;
      this.operateDialog = true;
      this.$nextTick(function () {
        _this4.$refs.operateForm.resetFields();
      });
    },
    addOperateLog: function addOperateLog() {
      var _this5 = this;
      this.$refs.operateForm.validate(function (valid) {
        if (valid) {
          addOperationLog(_objectSpread({
            order_id: _this5.orderId
          }, _this5.operateForm)).then(function (res) {
            _this5.$message.success('操作成功');
            _this5.operateDialog = false;
            _this5.operateLogPages.page = 1;
            _this5.loadOperateLog();
          });
        }
      });
    },
    loadOperateLog: function loadOperateLog() {
      var _this6 = this;
      getOperationLog({
        order_id: this.orderId,
        page: this.operateLogPages.page,
        page_size: this.operateLogPages.page_size
      }).then(function (res) {
        var _res$data, _res$pages;
        _this6.operateLogList = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || [];
        _this6.operateLogPages.totalCount = ((_res$pages = res.pages) === null || _res$pages === void 0 ? void 0 : _res$pages.totalCount) || 0;
      });
    },
    onChangeOperateLogPage: function onChangeOperateLogPage(page) {
      this.operateLogPages.page = page;
      this.loadOperateLog();
    },
    lookEvent: function lookEvent(row) {
      // 跟客服中心-客服工作台查看规则保持一致，后端说直接传order_id即可 不需要card_info_id
      this.this.drawerRule = true;
    },
    changeTab: function changeTab() {
      var _this7 = this;
      // 获取图表数据并重新绘制
      var cb = {
        1: this.getConsumeTrend,
        2: this.getOrderTrend,
        3: this.getCostRate,
        4: this.getCategoryCost
      }[this.activeNameChart];
      typeof cb === 'function' && this.activeName === '1' && cb(); // 只有activeName 为1时，才有显示图表
      if (this.activeName == 9) {
        this.getStatisticsAuditRisk();
      }
      if (this.activeNameChart == '5') {
        this.getOrderEvaluate();
      }
      if (this.activeNameChart == '6') {
        this.getPlateDetail();
      }
      if (this.activeName == 1 && this.activeNameChart == '7') {
        this.$nextTick(function () {
          _this7.$refs.cityStatistics && _this7.$refs.cityStatistics.getData();
        });
      }
      if (this.activeName == 1 && this.activeNameChart == '8') {
        this.$nextTick(function () {
          _this7.$refs.provinceStatistics && _this7.$refs.provinceStatistics.getData();
        });
      }
    },
    // 下单省份统计 - 点击省份跳转到下单城市统计
    onJumpCityStatistics: function onJumpCityStatistics(provinceCode) {
      var _this8 = this;
      this.activeNameChart = '7';
      this.$nextTick(function () {
        _this8.$refs.cityStatistics && _this8.$refs.cityStatistics.jumpWithProvince(provinceCode);
      });
    },
    changeCategoryCostPage: function changeCategoryCostPage(val) {
      this.categoryCostPaging.page = val;
      this.getCategoryCost();
    },
    getCategoryCost: function getCategoryCost() {
      var _this9 = this;
      var draw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      getCategoryCostTrend(_objectSpread({
        order_id: this.orderId
      }, this.categoryCostPaging), this.entry).then(function (res) {
        var _res$data2 = res.data,
          _res$data2$pie = _res$data2.pie,
          pie = _res$data2$pie === void 0 ? [] : _res$data2$pie,
          _res$data2$list = _res$data2.list,
          list = _res$data2$list === void 0 ? [] : _res$data2$list,
          _res$data2$total = _res$data2.total,
          total = _res$data2$total === void 0 ? {} : _res$data2$total;
        _this9.categoryCostList = list;
        if (_this9.categoryCostList.length > 0) {
          _this9.categoryCostList.unshift(_objectSpread(_objectSpread({}, total), {}, {
            category_name: '总计',
            order_business_type_name: '-',
            name: '-'
          }));
        }
        _this9.categoryCostPaging.totalCount = res.pages.totalCount;
        if (draw) {
          pie = pie.map(function (i) {
            return {
              name: i.category_name,
              occupancy: i.occupancy
            };
          });
          _this9.$nextTick(function () {
            _this9.echart2(pie, 'category_cost');
          });
        }
      });
    },
    // 商城菜单统计 - 导出
    onClickCategoryExport: function onClickCategoryExport() {
      var _this0 = this;
      var params = _objectSpread({
        order_id: this.orderId
      }, this.categoryCostPaging);
      getCategoryCostExport(params, this.entry).then(function (res) {
        if (res.data) {
          _this0.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
        }
      });
    },
    getConsumeTrend: function getConsumeTrend() {
      var _this1 = this;
      var draw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      _getConsumeTrend({
        orderId: this.orderId,
        gross_profit_type: this.gross_profit_type
      }, this.entry).then(function (res) {
        var _res$data3 = res.data,
          _res$data3$order_type = _res$data3.order_type,
          order_type = _res$data3$order_type === void 0 ? [] : _res$data3$order_type,
          _res$data3$business_t = _res$data3.business_type,
          business_type = _res$data3$business_t === void 0 ? [] : _res$data3$business_t,
          _res$data3$consume_sc = _res$data3.consume_scenario,
          consume_scenario = _res$data3$consume_sc === void 0 ? [] : _res$data3$consume_sc,
          _res$data3$order = _res$data3.order,
          order = _res$data3$order === void 0 ? {} : _res$data3$order,
          _res$data3$gross = _res$data3.gross,
          gross = _res$data3$gross === void 0 ? {} : _res$data3$gross,
          _res$data3$plate_type = _res$data3.plate_type,
          plate_type = _res$data3$plate_type === void 0 ? [] : _res$data3$plate_type;
        _this1.orderTypeList = order_type;
        _this1.businessTypeList = plate_type;
        _this1.consumeScenarioList = consume_scenario;
        _this1.orderInfo = order;
        _this1.grossInfo = gross;
        var _this1$orderInfo = _this1.orderInfo,
          id = _this1$orderInfo.id,
          card_bin_group_id = _this1$orderInfo.card_bin_group_id;
        _this1.trendParams = {
          order_id: id,
          entryType: 'platformQueryManage',
          menuType: 'platformQueryManage',
          cardBinGroupId: card_bin_group_id,
          flag: 'order' // 订单礼包卷进入
        };
        if (draw) {
          _this1.$nextTick(function () {
            _this1.echart2(order_type, 'order');
            _this1.echart2(plate_type, 'business');
            _this1.echart2(consume_scenario, 'consume');
          });
        }
      });
    },
    echart2: function echart2(data, type) {
      var seriesData = data.filter(function (i) {
        return i.name !== '总计';
      }) // 后端要求根据该名字删除掉总计数据绘图
      .map(function (i) {
        return {
          value: i.occupancy,
          name: i.name
        };
      });
      var chartDom = this.$refs["datascren_".concat(type)];
      var myChart = this.$echarts.init(chartDom);
      var title = {
        order: '订单类型消费',
        business: '业务类型消费',
        consume: '消费场景'
      }[type] + '占比';
      if (type === 'category_cost') {
        title = '商城菜单统计';
      }
      var option = {
        title: {
          text: title,
          x: 'center'
        },
        legend: {
          icon: 'circle',
          // 修改形状
          itemHeight: 6,
          // 修改icon图形大小
          itemGap: 5,
          // 修改间距
          textStyle: {
            color: '#333',
            fontSize: 10,
            padding: [0, 0, 0, -12] // 修改文字和图标距离
          },
          top: '30px'
        },
        grid: {
          top: '0'
        },
        tooltip: {
          trigger: 'item',
          valueFormatter: function valueFormatter(value) {
            return value + '%';
          },
          confine: true // 是否将 tooltip 框限制在图表的区域内。
        },
        // toolbox: {
        // 	feature: {
        // 		dataView: { show: false, readOnly: false },
        // 		magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
        // 		restore: { show: true },
        // 		saveAsImage: { show: true }
        // 	}
        // },
        series: [{
          type: 'pie',
          radius: '50%',
          label: {
            formatter: "{b}{c}%"
          },
          data: seriesData
        }]
      };
      option && myChart.setOption(option);
    },
    // 获取页面数据
    getOrderTrend: function getOrderTrend(type) {
      var _this10 = this;
      var params = {
        orderId: this.orderId,
        gross_profit_type: this.gross_profit_type,
        order_type: this.cost_order_type
      };
      _getOrderTrend(params, this.entry).then(function (res) {
        var _res$data4 = res.data,
          _res$data4$order = _res$data4.order,
          order = _res$data4$order === void 0 ? {} : _res$data4$order,
          _res$data4$gross = _res$data4.gross,
          gross = _res$data4$gross === void 0 ? {} : _res$data4$gross,
          _res$data4$trend = _res$data4.trend,
          trend = _res$data4$trend === void 0 ? {} : _res$data4$trend,
          _res$data4$types = _res$data4.types,
          types = _res$data4$types === void 0 ? [] : _res$data4$types;
        if (type === 'update_gross') {
          _this10.grossInfo = gross;
          return;
        }
        _this10.orderInfo = order;
        _this10.grossInfo = gross;
        _this10.list = trend.list;
        _this10.statsData = trend.chart;
        _this10.costTypeList = [].concat(_toConsumableArray(types.length > 0 ? [{
          name: '全部',
          type: ''
        }] : []), _toConsumableArray(types));
        _this10.$nextTick(function () {
          _this10.echart();
        });
      });
    },
    // 订单成本率趋势 start
    // 获取数据
    getCostRate: function getCostRate() {
      var _this11 = this;
      var _ref = this.searchForm.date_time || [],
        _ref2 = _slicedToArray(_ref, 2),
        _ref2$ = _ref2[0],
        start_date = _ref2$ === void 0 ? '' : _ref2$,
        _ref2$2 = _ref2[1],
        end_date = _ref2$2 === void 0 ? '' : _ref2$2;
      getCostRateData(_objectSpread({
        order_type: this.searchForm.rate_order_type,
        start_date: start_date,
        end_date: end_date,
        order_id: this.orderId
      }, this.paging), this.entry).then(function (res) {
        var _res$data5 = res.data,
          _res$data5$chart = _res$data5.chart,
          chart = _res$data5$chart === void 0 ? {} : _res$data5$chart,
          _res$data5$list = _res$data5.list,
          list = _res$data5$list === void 0 ? [] : _res$data5$list,
          _res$data5$types = _res$data5.types,
          types = _res$data5$types === void 0 ? [] : _res$data5$types;
        _this11.costRateList = list;
        _this11.rateTypeList = [].concat(_toConsumableArray(types.length > 0 ? [{
          name: '全部',
          type: ''
        }] : []), _toConsumableArray(types));
        _this11.costRateChart = chart;
        _this11.paging.totalCount = res.pages.totalCount;
        _this11.$nextTick(function () {
          _this11.echart3();
        });
      });
    },
    // 售后数据
    getOrderEvaluate: function getOrderEvaluate() {
      var _this12 = this;
      exportOrderEvaluate({
        orderId: this.orderId
      }).then(function (res) {
        _this12.order_evaluate = res.data && res.data.order_evaluate || {};
        _this12.evaluateList = res.data && [res.data.order_evaluate] || [];
      });
    },
    // 评价明细 - 打开 drawer
    onOpenEvaluateDetail: function onOpenEvaluateDetail() {
      this.evaluateDetailVisible = true;
    },
    // 评价明细 - 关闭 drawer
    onCloseEvaluateDetail: function onCloseEvaluateDetail() {
      this.evaluateDetailVisible = false;
    },
    // 板块明细
    goPlateDetail: function goPlateDetail() {
      this.activeNameChart = '6';
      this.getPlateDetail();
    },
    getPlateDetail: function getPlateDetail() {
      var _this13 = this;
      getPlateDetailPieChart({
        orderId: this.orderId
      }).then(function (res) {
        _this13.plateDetailList = res.data && res.data.plate_type || [];
        _this13.pageDesc = res.data && res.data.page_desc || '';
        _this13.$nextTick(function () {
          var configMap = {
            1: {
              ref: 'datascren_onlineShop',
              title: '视听板块明细',
              nameKey: 'order_type_name'
            },
            2: {
              ref: 'datascren_media',
              title: '线上商城明细',
              nameKey: 'category_name'
            },
            3: {
              ref: 'datascren_birthday',
              title: '生日板块明细',
              nameKey: 'order_type_name'
            },
            4: {
              ref: 'datascren_third-party_supermarket',
              title: '本地商超明细',
              nameKey: 'brand_name'
            }
          };
          _this13.plateDetailList.forEach(function (item) {
            var config = configMap[item.type];
            if (config && _this13.$refs[config.ref]) {
              _this13.renderPlatePieChart(item.data, config.ref, config.title, config.nameKey);
            }
          });
        });
      });
    },
    renderPlatePieChart: function renderPlatePieChart(data, refName, title, nameKey) {
      var chartDom = this.$refs[refName];
      if (!chartDom) return;
      var myChart = this.$echarts.init(chartDom);
      var seriesData = data.filter(function (i) {
        return i.order_plate_type_name !== '总计';
      }).map(function (i) {
        return {
          value: i.occupancy,
          name: i[nameKey] || i.order_type_name || ''
        };
      });
      var option = {
        title: {
          text: title,
          x: 'center'
        },
        legend: {
          icon: 'circle',
          itemHeight: 6,
          itemGap: 5,
          textStyle: {
            color: '#333',
            fontSize: 10,
            padding: [0, 0, 0, -12]
          },
          top: '30px'
        },
        grid: {
          top: '0'
        },
        tooltip: {
          trigger: 'item',
          valueFormatter: function valueFormatter(value) {
            return value + '%';
          },
          confine: true
        },
        series: [{
          type: 'pie',
          radius: '50%',
          label: {
            formatter: '{b}{c}%'
          },
          data: seriesData
        }]
      };
      myChart.setOption(option, true);
    },
    getStatisticsAuditRisk: function getStatisticsAuditRisk() {
      var _this14 = this;
      _getStatisticsAuditRisk({
        order_id: this.orderId,
        is_plat: 1 //  1 平台 0 数据中心
      }).then(function (res) {
        if (res.data.order_id > 0) {
          _this14.orderType = 1;
        } else {
          _this14.orderType = 2;
        }
        _this14.cardRuleList = [];
        if (res.data.rule_integral_value_config == 1) {
          _this14.cardRuleList.push({
            group: '卡规则',
            checkOrder: '卡规则开启了积分价值',
            result_str: res.data.rule_integral_value_config_result_str,
            trigger_audit: res.data.rule_integral_value_config_type
          });
          // 卡规则开启了跨业务类型卡合并
        }
        if (res.data.rule_is_merge_config == 1) {
          _this14.cardRuleList.push({
            group: '卡规则',
            checkOrder: '卡规则开启了跨业务类型卡合并',
            result_str: res.data.rule_is_merge_config_result_str,
            trigger_audit: res.data.rule_is_merge_config_type
          });
          // 卡规则设置了充值折扣
        }
        if (res.data.rule_recharge_ratio_config == 1) {
          _this14.cardRuleList.push({
            group: '卡规则',
            checkOrder: '卡规则设置了充值折扣',
            result_str: res.data.rule_recharge_ratio_config_result_str,
            trigger_audit: res.data.rule_recharge_ratio_config_type
          });

          // 商城装修风格为开放式
        }
        if (res.data.commomn_shop_decoration_config == 1) {
          _this14.cardRuleList.push({
            group: '装修',
            checkOrder: '商城装修风格为开放式',
            result_str: res.data.commomn_shop_decoration_config_result_str,
            trigger_audit: res.data.commomn_shop_decoration_config_type
          });
        }
        // 个性化装修:商城装修风格为自定义风格
        if (res.data.shop_decoration_config == 1) {
          _this14.cardRuleList.push({
            group: '装修',
            checkOrder: '个性化装修:商城装修风格为自定义风格',
            result_str: res.data.shop_decoration_config_type_result_str,
            trigger_audit: res.data.shop_decoration_config_type
          });
        }
        // 个性化装修:包含礼包预览链接
        if (res.data.shop_decoration_programme_preview_config == 1) {
          _this14.cardRuleList.push({
            group: '装修',
            checkOrder: '个性化装修:包含礼包预览链接',
            result_str: res.data.shop_decoration_programme_preview_config_result_str,
            trigger_audit: res.data.shop_decoration_programme_preview_config_type
          });
        }
        // 个性化装修:本次发的卡，卡规则的菜单在首页中不存在
        if (res.data.shop_decoration_menu_config == 1) {
          _this14.cardRuleList.push({
            group: '装修',
            checkOrder: '个性化装修:本次发的卡，卡规则的菜单在首页中不存在',
            result_str: res.data.shop_decoration_menu_config_result_str,
            trigger_audit: res.data.shop_decoration_menu_config_type
          });
        }
        // 分类页做了个性化装修
        if (res.data.shop_decoration_category_user_defined_config == 1) {
          _this14.cardRuleList.push({
            group: '装修',
            checkOrder: '分类页做了个性化装修',
            result_str: res.data.shop_decoration_category_user_defined_config_result_str,
            trigger_audit: res.data.shop_decoration_category_user_defined_config_type
          });
        }

        // 客户级营销参数与渠道不一致(电影除外)
        if (res.data.discount_marketing_config == 1) {
          _this14.cardRuleList.push({
            group: '折扣',
            checkOrder: '客户级营销参数与渠道不一致(电影除外)',
            result_str: res.data.discount_marketing_config_result_str,
            trigger_audit: res.data.discount_marketing_config_type
          });
        }
        // 商品中心-客户级调价规则
        if (res.data.discount_shop_customer_price_config == 1) {
          _this14.cardRuleList.push({
            group: '折扣',
            checkOrder: '商品中心-客户级调价规则',
            result_str: res.data.discount_shop_customer_price_config_result_str,
            trigger_audit: res.data.discount_shop_customer_price_config_type
          });
        }
        // 个性化菜单-客户级调价规则
        if (res.data.discount_menu_customer_price_config == 1) {
          _this14.cardRuleList.push({
            group: '折扣',
            checkOrder: '个性化菜单-客户级调价规则',
            result_str: res.data.discount_menu_customer_price_config_result_str,
            trigger_audit: res.data.discount_menu_customer_price_config_type
          });
        }
        // 客户级菜单 个性化参数
        if (res.data.menu_profit_rate_config == 1) {
          _this14.cardRuleList.push({
            group: '折扣',
            checkOrder: "\n\t\t\t\t\t\t\t<div>\u3010\u5B9E\u4F53\u5546\u54C1\u3011\u5BA2\u6237\u7EA7\u83DC\u5355\uFF08\u6807\u51C6+\u4E2A\u6027\u5316\uFF09\u5229\u6DA6\u7387\u53C2\u6570<".concat(res.data.entity_menu_profit_rate, "%</div>\n\t\t\t\t\t\t\t<div>\u3010\u7535\u5B50\u5361\u5BC6\u3011\u5BA2\u6237\u7EA7\u83DC\u5355\uFF08\u6807\u51C6+\u4E2A\u6027\u5316\uFF09\u5229\u6DA6\u7387\u53C2\u6570<").concat(res.data.card_menu_profit_rate, "%</div>\n\t\t\t\t\t\t\t<div>\u3010\u865A\u62DF\u4F1A\u5458\u76F4\u5145\u3011\u5BA2\u6237\u7EA7\u83DC\u5355\uFF08\u6807\u51C6+\u4E2A\u6027\u5316\uFF09\u5229\u6DA6\u7387\u53C2\u6570<").concat(res.data.virtual_member_menu_profit_rate, "%</div>\n\t\t\t\t\t\t\t<div>\u3010\u86CB\u7CD5\u5230\u5BB6\u3011\u5BA2\u6237\u7EA7\u83DC\u5355\uFF08\u6807\u51C6+\u4E2A\u6027\u5316\uFF09\u5229\u6DA6\u7387\u53C2\u6570<").concat(res.data.cake_store_menu_profit_rate, "%</div>\n\t\t\t\t\t\t"),
            result_str: res.data.menu_profit_rate_config_result_str,
            trigger_audit: res.data.menu_profit_rate_config_type,
            viewPage: 9
          });
        }

        // 礼包方案包含自组礼包
        if (res.data.programme_self_choose_config == 1) {
          _this14.cardRuleList.push({
            group: '礼包方案',
            checkOrder: '礼包方案包含自组礼包',
            result_str: res.data.programme_self_choose_config_result_str,
            trigger_audit: res.data.programme_self_choose_config_type
          });
        }
        // 礼包方案包含自选商城
        if (res.data.programme_menus_config == 1) {
          _this14.cardRuleList.push({
            group: '礼包方案',
            checkOrder: '礼包方案包含自选商城',
            result_str: res.data.programme_menus_config_result_str,
            trigger_audit: res.data.programme_menus_config_type
          });
        }
        // 礼包方案存在溢价
        if (res.data.programme_premium_price_config == 1) {
          _this14.cardRuleList.push({
            group: '礼包方案',
            checkOrder: '礼包方案存在溢价',
            result_str: res.data.programme_premium_price_config_result_str,
            trigger_audit: res.data.programme_premium_price_config_type
          });
        }
        // 礼包方案利润率参数个性化
        if (res.data.programme_profit_rate_config == 1) {
          _this14.cardRuleList.push({
            group: '礼包方案',
            checkOrder: '礼包方案利润率参数个性化',
            result_str: res.data.programme_profit_rate_config_result_str,
            trigger_audit: res.data.programme_profit_rate_config_type
          });
        }
        if (res.data.order_contract_config == 1) {
          _this14.cardRuleList.push({
            group: '合同',
            checkOrder: '订单未签署合同',
            result_str: res.data.order_contract_config_result_str,
            trigger_audit: res.data.order_contract_config_type
          });
        }
      });
    },
    // 绘制折线图
    echart3: function echart3() {
      var _this15 = this;
      var chartDom = this.$refs.costRate;
      var myChart = this.$echarts.init(chartDom);
      var series = [{
        name: '当日成本率',
        type: 'line',
        data: this.costRateChart.current
      }, {
        name: '累计成本率',
        type: 'line',
        data: this.costRateChart.cumulative
      }];
      var option = {
        title: {
          text: '订单消费成本率趋势',
          x: 'center'
        },
        legend: {
          data: series.map(function (i) {
            return i.name;
          }),
          top: '30px'
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          // 是否将 tooltip 框限制在图表的区域内。
          formatter: function formatter(arg) {
            var str = "<div>".concat(arg[0]['name'], "</div>");
            arg.forEach(function (i) {
              str += "<div>\n\t\t\t\t\t\t\t\t\t\t\t\t".concat(i['marker'], "\n\t\t\t\t\t\t\t\t\t\t\t\t<span>").concat(i['seriesName'], "</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<b>").concat(i['value'], "%</b>\n\t\t\t\t\t\t\t\t\t\t\t</div>");
            });
            var index = arg[0].dataIndex;
            var logs = _this15.costRateChart.logs[index] || [];
            var logsHTML = '';
            if (Array.isArray(logs) && logs.length > 0) {
              logsHTML = '<div style="margin:5px 0;border-top:1px dashed #333"></div>';
              logs.forEach(function (i) {
                logsHTML += "<div>".concat(i.created_at, " ").concat(i.text, "</div>");
              });
            }
            return str + logsHTML;
          }
          // valueFormatter: value => `${value}%`
        },
        toolbox: {
          feature: {
            dataView: {
              show: false,
              readOnly: false
            },
            magicType: {
              show: true,
              type: ['line', 'bar', 'stack', 'tiled']
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        grid: {
          left: '8',
          right: '5%',
          bottom: '10',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            // rotate: 60 // 倾斜的程度
          },
          data: this.costRateChart.date
        },
        yAxis: {
          type: 'value',
          min: 'dataMin',
          max: 'dataMax',
          axisLabel: {
            formatter: '{value}%'
          }
        },
        series: series
      };
      option && myChart.setOption(option);
    },
    changePage: function changePage(val) {
      this.paging.page = val;
      this.getCostRate();
    },
    downFileCost: function downFileCost() {
      var _this16 = this;
      exportCostRange({
        order_id: this.orderId
      }).then(function (res) {
        if (res.data) {
          _this16.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地'); //
        }
      });
    },
    // 订单成本率趋势 end
    // 导出
    downFile: function downFile() {
      var _this17 = this;
      var params = {
        orderId: this.orderId
      };
      params.download = 1;
      exportOrderTrend(params, this.entry).then(function (res) {
        if (res.data) {
          _this17.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地'); //
        }
      });
    },
    echart: function echart() {
      var _this$statsData,
        _this$statsData$serie,
        _this18 = this;
      var _this = this;
      var chartDom = this.$refs.datascren;
      var myChart = this.$echarts.init(chartDom);
      var series = [];
      (_this$statsData = this.statsData) === null || _this$statsData === void 0 ? void 0 : (_this$statsData$serie = _this$statsData.series) === null || _this$statsData$serie === void 0 ? void 0 : _this$statsData$serie.forEach(function (item, index) {
        if (item.name.indexOf('占比') != -1 || item.name === '累计消费预警值') {
          series.push(item);
        }
      });
      var option;
      var legendData = series.map(function (i) {
        return i.name;
      });
      if (this.cost_order_type !== '') {
        legendData.forEach(function (key, index, arr) {
          var data = series.find(function (item) {
            return item.name === key;
          });
          data.name = _this18.new_legend[index];
          arr[index] = _this18.new_legend[index];
        });
      }
      option = {
        color: '#4A7DD7',
        title: {
          text: '订单消费占比趋势',
          x: 'center'
        },
        legend: {
          // data: this.statsData.legend
          data: legendData,
          top: '30px'
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,0.8)',
          // 设置背景颜色
          confine: true,
          // 是否将 tooltip 框限制在图表的区域内。
          formatter: function formatter(arg) {
            var index = arg[0].dataIndex;
            var list = _toConsumableArray(_this.list).reverse();
            var logs = list[index].logs || [];
            var logsHTML = logs.length > 0 ? '<div style="margin:5px 0;border-top:1px dashed #333"></div>' : '';
            logs.forEach(function (i) {
              logsHTML += "<div>".concat(i.created_at, " ").concat(i.text, "</div>");
            });
            return "\n                <div>".concat(arg[0].name, "\uFF08").concat(list[index].stat_date, "\uFF09</div>\n                ").concat(_this.cost_order_type === '' ? "<div>\u552E\u5361\u70B9\u6570\uFF1A".concat(list[index].total_amount, "</div>") : '', "\n                <div>\u5F53\u65E5\u6D88\u8D39\u70B9\u6570").concat(_this.order_type_cn ? "(".concat(_this.order_type_cn, ")") : '', "\uFF1A").concat(list[index].consume_points, "</div>\n                <div>\u7D2F\u8BA1\u6D88\u8D39\u70B9\u6570").concat(_this.order_type_cn ? "(".concat(_this.order_type_cn, ")") : '', "\uFF1A").concat(list[index].cumulative_consume_amount, "</div>\n                <div>").concat(_this.order_type_cn ? "".concat(_this.new_legend[0]) : '当日消费占比', "\uFF1A").concat(list[index].consume_ratio, "%</div>\n                <div>").concat(_this.order_type_cn ? "".concat(_this.new_legend[1]) : '累计消费占比', "\uFF1A").concat(list[index].cumulative_consume_ratio, "%</div>\n\t\t\t\t\t\t\t\t").concat(_this.cost_order_type === '' ? "<div>\u7D2F\u8BA1\u6D88\u8D39\u9884\u8B66\u503C\uFF1A".concat(list[index].alarm_number, "%</div>") : '', "\n\t\t\t\t\t\t\t\t").concat(logsHTML, "\n              ");
          }
        },
        toolbox: {
          feature: {
            // dataZoom: {
            //   yAxisIndex: false
            // },
            dataView: {
              show: false,
              readOnly: false
            },
            magicType: {
              show: true,
              type: ['line', 'bar', 'stack', 'tiled']
            },
            restore: {
              show: true
            },
            saveAsImage: {
              show: true
            }
          }
        },
        // （1）'line'，折线图。
        // （2）'bar'，柱形图。
        // （3）'stack'，堆叠模式。
        // （4）'tiled'，平铺模式。
        grid: {
          left: '8',
          right: '5%',
          bottom: '10',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            // interval: 0
            // rotate: 60 // 倾斜的程度
          },
          data: this.statsData.category
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        },
        series: series
      };
      option && myChart.setOption(option, true);
    }
  },
  created: function created() {
    this.activeName = this.activeNameDefault || '1';
    this.activeNameChart = this.detailActiveName || '1';
    this.gross_profit_type = this.searchData.gross_profit_type + '';
    this.changeTab();
    this.loadOperateLog();
    this.getOrderLog();
    if (this.activeName != '1' || this.activeNameChart != '1') {
      // 不是订单信息tab时，也要获取订单信息中的字段 客户配置 订单规则中需要使用 但不能绘制图表
      this.getConsumeTrend(false);
    }
  },
  computed: {
    selectData: function selectData() {
      var val = Number(this.order_evaluate.satisfied_num) || 0;
      return {
        satisfied_num: val * 180 + 'deg'
      };
    },
    plateData1: function plateData1() {
      var item = this.plateDetailList.find(function (i) {
        return i.type === 1;
      });
      return item ? item.data : [];
    },
    plateData2: function plateData2() {
      var item = this.plateDetailList.find(function (i) {
        return i.type === 2;
      });
      return item ? item.data : [];
    },
    plateData3: function plateData3() {
      var item = this.plateDetailList.find(function (i) {
        return i.type === 3;
      });
      return item ? item.data : [];
    },
    plateData4: function plateData4() {
      var item = this.plateDetailList.find(function (i) {
        return i.type === 4;
      });
      return item ? item.data : [];
    },
    new_legend: function new_legend() {
      return ["\u5F53\u65E5\u6D88\u8D39\u70B9\u6570(".concat(this.order_type_cn, ")/\u5F53\u65E5\u6D88\u8D39\u70B9\u6570(\u5168\u90E8)"), "\u7D2F\u8BA1\u6D88\u8D39\u70B9\u6570(".concat(this.order_type_cn, ")/\u7D2F\u8BA1\u6D88\u8D39\u70B9\u6570(\u5168\u90E8)")];
    },
    order_type_cn: function order_type_cn() {
      var _this19 = this;
      if (this.cost_order_type === '') {
        return '';
      }
      var current_type = this.costTypeList.find(function (i) {
        return i.type === _this19.cost_order_type;
      });
      return current_type.name;
    }
  }
};